import React from "react";
import { Alert, Box, FormLabel, Tooltip } from "@mui/material";
import { HelpOutlined } from "@mui/icons-material";

export interface SimpleFormLabelProps {
  tooltip?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export default function SimpleFormLabel(props: SimpleFormLabelProps) {

  const [descriptionOpen, setDescriptionOpen] = React.useState(false);

  return (
    <Box sx={{ margin:"10px 0 5px", position:"relative"}} >
      {props.tooltip &&
        <>
        <Tooltip title={props.tooltip} followCursor>
          <FormLabel sx={{ fontSize:"1rem" }} onClick={() => setDescriptionOpen(!descriptionOpen)} {...props}>
            {props.children}
            <HelpOutlined sx={{fontSize: "0.9em", opacity:"0.7", margin:"3px 0 0 5px"}}/>
          </FormLabel>
        </Tooltip>
        {descriptionOpen &&
          <Alert severity="info" sx={{ margin:"10px 0 5px" }}>
            {props.tooltip}
          </Alert>
        }
        </>
      }
      {!props.tooltip &&
        <FormLabel sx={{ fontSize:"1rem" }} {...props}> {props.children} </FormLabel>
      }
      {props.actions &&
        <Box sx={{ position:"absolute", right:0, top:0 }}>
          {props.actions}
        </Box>
      }
    </Box>
  );
}